import React, { useEffect, useRef, useState } from "react";

import "./input.scss";
import emailjs from "@emailjs/browser";

const Input = () => {
  // This function validates emails
  const validateEmail = (email) => {
    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).toLowerCase());
  };

  const [enteredName, setEnteredName] = useState("");
  const [enteredEmail, setEnteredEmail] = useState("");
  const [addText, setAddText] = useState("");
  const changeText = (e) => {
    setAddText(e.target.value);
    if (e.target.value.trim() !== "") {
      setShowTextError("");
    } else {
      setShowTextError("Text is a required field");
    }
  };

  const [showError, setShowError] = useState("");
  const [showEmailError, setShowEmailError] = useState("");
  const [showTextError, setShowTextError] = useState("");
  console.log(showTextError, "showTextError");

  const changeNameHandler = (e) => {
    setEnteredName(e.target.value);
    if (e.target.value.trim() !== "") {
      setShowError("");
    } else {
      setShowError("Name is required");
    }
  };

  const changeEmailHandler = (e) => {
    setEnteredEmail(e.target.value);
    if (validateEmail(e.target.value.trim() !== "")) {
      setShowError("");
    } else {
      setShowError("Email is required");
    }
  };

  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log(result.text);

          form.current.reset();
        },
        (error) => {
          console.log(error.text);
        }
      );
    setEnteredName("");
    setEnteredEmail("");
    setAddText("");
  };

  const isFormValid =
    enteredName.trim() !== "" &&
    validateEmail(enteredEmail) &&
    addText.trim() != "";

  useEffect(() => {
    const timer = setTimeout(() => {
      if (enteredEmail.trim() !== "") {
        if (!validateEmail(enteredEmail)) {
          setShowEmailError(
            "this doesn't look like an email ,pleas check it again  "
          );
        } else {
          setShowEmailError("");
        }
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [enteredEmail]);

  return (
    <div className="contact-wrapper">
      <form ref={form} className="contact100-form ">
        <div className="wrap-input100  ">
          <input
            className="input100"
            value={enteredName}
            onChange={changeNameHandler}
            placeholder="First name"
            name="user-name"
            id="name"
          />

          <span className="focus-input100"></span>
          <span className="symbol-input100">
            <i className="fa fa-user" aria-hidden="true"></i>
          </span>
        </div>
        {showError && (
          <p style={{ color: "#ff0808cc", paddingBottom: "7px " }}>
            {showError}
          </p>
        )}
        <div className="wrap-input100  ">
          <input
            className="input100"
            value={enteredEmail}
            onChange={changeEmailHandler}
            placeholder="Email"
            name="user-email"
            id="email"
          />

          <span className="focus-input100"></span>
          <span className="symbol-input100">
            <i className="fa fa-envelope" aria-hidden="true"></i>
          </span>
        </div>
        {showEmailError && (
          <p style={{ color: "#ff0808cc", paddingBottom: "12px " }}>
            {showEmailError}
          </p>
        )}

        <div className="wrap-input100 ">
          <textarea
            className="input100"
            value={addText}
            onChange={changeText}
            type="text"
            placeholder="leave a text"
            rows="5"
            cols="37"
            id="message"
            name="message"
          ></textarea>
          <span className="focus-input100"></span>
        </div>
        {showTextError && (
          <p style={{ color: "#ff0808cc", paddingTop: "12px " }}>
            {showTextError}
          </p>
        )}
        <div className="container-contact100-form-btn">
          <button
            className="contact100-form-btn"
            onClick={sendEmail}
            disabled={!isFormValid}
            style={{
              cursor: !isFormValid ? "no-drop" : "pointer",
              backgroundColor: !isFormValid ? "rgb(84 27 71)" : "#BC379E",
            }}
          >
            send
          </button>
        </div>
      </form>
    </div>
  );
};

export default Input;
